<div [ngClass]="['main-layout', (isAGGIOC ? ' an-giang-ioc-theme' : '')]">
    <mat-sidenav-container class="sidenav-container">
        <mat-sidenav #drawer class="sidenav" fixedInViewport="false" [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'" [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
            <div class="logo-contain">
                <a routerLink="/trang-chu">
                    <img [src]="logoSrc" alt="Logo">
                    <h2 class="fs-16">{{title}}</h2>
                </a>
            </div>
            <div *ngIf="(isHandset$ | async) === true">
                <ng-container *ngTemplateOutlet="headerTool"></ng-container>
            </div>
            <div class="menu-search-wrapper">
                <mat-form-field appearance="outline" class="input-group w100 menu-search">
                    <mat-icon matPrefix>search</mat-icon>
                    <input matInput placeholder="Tìm menu..." [(ngModel)]="searchText" (input)="onSearchChange()" (keydown.enter)="onSearchEnter()" />
                </mat-form-field>
            </div>
            <div class="dropdown-divider m-b-10 m-l-90 m-r-90"></div>
            <ng-material-multilevel-menu *ngIf="appitems && appitems.length > 0" [items]='appitems' [configuration]='config' (selectedItem)="selectedItem($event)">
                <ng-template #listTemplate let-item="item" let-configuration="configuration" class="b-b">
                    <div class="left-menu" [dir]="configuration.rtlLayout  ? 'rtl' : 'ltr'" [class.choose]="item.expanded">
                        <div class="title-and-image">
                            <div class="label-container">
                                <span *ngIf="item.hasChilden">
                                  {{ item.label }}
                                  <!-- <span class="right badge" [ngStyle]="{'background-color': item.color}" *ngIf="item.badge && item.badge != ''"> {{ item.badge }} </span> -->
                                </span>
                                <a *ngIf="!item.hasChilden" style="text-decoration: none;color: white;" [routerLink]="item.link">
                                    {{ item.label }}
                                </a>
                            </div>
                        </div>
                        <div class="icon-arrow-container" *ngIf='item.hasChilden'>
                            <mat-icon *ngIf="!configuration.rtlLayout" [@ExpandedLTR]="item.expanded ? 'yes' : 'no'"> keyboard_arrow_down </mat-icon>
                            <mat-icon *ngIf="configuration.rtlLayout" [@ExpandedRTL]="item.expanded ? 'yes' : 'no'"> keyboard_arrow_down </mat-icon>
                        </div>
                    </div>
                </ng-template>
            </ng-material-multilevel-menu>
        </mat-sidenav>
        <mat-sidenav-content fxFlex='100' class="b-whitesmoke">
            <mat-toolbar class="toolbar">
                <button mat-icon-button (click)="drawer.toggle()" class="example-icon" aria-label="Example icon-button with menu icon">
                    <mat-icon> menu </mat-icon>
                </button>
                <b class="company" *ngIf="this.user.maTinhBhxh != '89'"> {{ title }}</b> <!-- Tạm ẩn nội dung này đối với AGG -->
                <span class="t-flex"></span>
                <div *ngIf="(isHandset$ | async) === false">
                    <ng-container *ngTemplateOutlet="headerTool"></ng-container>
                </div>
            </mat-toolbar>
            <!-- Không show footer đối với giao diện IOC của AGG -->
            <mat-toolbar [ngClass]="'footer' + (isAGGIOC ? ' d-none' : '')">
                <div class="row">
                    <div class="col-md-12 dungchung"> <span *ngIf="maTinh != '86'"> &copy; 2021. </span>Sản phẩm của Tập đoàn Bưu chính Viễn thông Việt Nam - VNPT </div>
                </div>
            </mat-toolbar>
            <!-- Không apply class p-d-content đối với giao diện IOC của AGG -->
            <div [ngClass]="!isAGGIOC ? 'p-d-content' : ''">
                <router-outlet></router-outlet>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>

    <ng-template #headerTool>
        <div [ngClass]="{'headerButton': (isHandset$ | async) === true}">
            <a routerlink="/accounts" mat-icon-button class="mat-focus-indicator mat-icon-button mat-button-base" href="/trang-chu">
                <span class="mat-button-wrapper">
                    <mat-icon data-mat-icon-type="font"> home </mat-icon>
                </span>
            </a>
            <button mat-button [matMenuTriggerFor]="beforeMenu" class="dropButton border-com p-l-10 p-r-10 f-small">
                <img [src]="avatar" class="avatar w-20"> {{ username }}
                <mat-icon> arrow_drop_down </mat-icon>
            </button>
            <mat-menu #beforeMenu="matMenu" xPosition="before" class="dropButton">
                <button mat-menu-item (click)="openModal('userInfo'); userInfo()">
                    <mat-icon> dialpad </mat-icon> 
                    <span class="dropButton"> Thông tin cá nhân </span>
                </button>
                <button mat-menu-item *ngIf="user.idDoanhNghiep" (click)="openModal('addThongTinDoanhNhiep'); resetForm(addForm,formDirective);apiGetThongTinChiTiet(user.idDoanhNghiep);">
                    <mat-icon> business </mat-icon>
                    <span> {{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.THONG_TIN_DOANH_NGHIEP' | translate }} </span>
                </button>
                <button mat-menu-item (click)="openModal('password')">
                    <mat-icon> password </mat-icon>
                    <span class="dropButton"> Thay đổi mật khẩu </span>
                </button>
                <button mat-menu-item (click)="ngOnInitUserId();openModal('modalUserId_admin')">
                    <mat-icon> edit_note </mat-icon>
                    <span class="dropButton"> Nhập tài khoản quản lý văn bản </span>
                </button>
                <button mat-menu-item (click)="logout()">
                    <mat-icon> voicemail </mat-icon>
                    <span class="dropButton"> Đăng xuất </span>
                </button>
            </mat-menu>
            <span *ngIf="maTinh != '86'">
            <button mat-button [matMenuTriggerFor]="langMenu" class="dropButton dungcss border-com" *ngIf="localeId == 'vi'">
                <img src="assets/icon/VI.png" class="flag">
            </button>
            <button mat-button [matMenuTriggerFor]="langMenu" class="dropButton dungcss border-com" *ngIf="localeId == 'en'">
                <img src="assets/icon/coAnh.jpg" class="flag">
            </button>
            <mat-menu #langMenu="matMenu" xPosition="before" class="dropButton">
                <button mat-menu-item (click)="changeLanguage('vi')" class="langBtn">
                    <img src="assets/icon/VI.png" class="flag"> &nbsp;&nbsp;
                    <span class="langAcronym"> Tiếng Việt </span>
                </button>
                <button mat-menu-item (click)="changeLanguage('en')" class="langBtn">
                    <img src="assets/icon/coAnh.jpg" id="lang_flag" class="flag"> &nbsp;&nbsp;
                    <span class="langAcronym"> English </span>
                </button>
            </mat-menu>
            </span>

            <div class="ul-notification" *ngIf="maTinh != '86'">
                <div id="div-bell" class="icon-notify animated infinite swing" (click)="openBell()">
                    <a href="javascript:void(0)"><i class="fa fa-bell"></i><span class="notify-count"> {{ DATA_NOTIFICATION_CENTER.length }} </span></a>
                </div>
                <div class="sidebar-notify">
                    <div class="row notify-title">
                        <div class="col-sm-12"> <h3> TRUNG TÂM THÔNG BÁO </h3> </div>
                    </div>
                    <div class="notify-content">
                        <p class="no-data" *ngIf="DATA_NOTIFICATION_CENTER.length == 0"> Không có thông báo mới! </p>
                        <div class="item-notify" *ngFor="let notify of DATA_NOTIFICATION_CENTER">
                            <div class="row item">
                                <div class="item-content" (click)="notify.topic == 'btxh' ? goToDetailMember(notify.uuid_ho, notify.uuid_nhan_khau) : ''">
                                    <p class="title-notification"> {{ notify.title }} </p>
                                    <p class="content-notifiction"> {{ notify.message }} </p>
                                    <p class="time-notification"> {{ notify.CreateDate | date: "dd/MM/yyyy HH:mm:ss" }} </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</div>

<div class="modal fade lims-custom-dialog scroll-dialog" id="userInfo" role="dialog">
    <div class="modal-dialog modal-lg modal-lg-dlg-custom">
        <div class="modal-content">
            <div class="modal-header">
                <div class="title-dialog">
                    <label> Thông tin người dùng </label>
                </div>
            </div>
            <form [formGroup]="userInfoForm">
            <div class="modal-body p-d-50">
                <div class="row">
                    <div class="col-md-3">
                        <img [src]="avatar" class="avatar w-20" style="margin-bottom: 20px;"> 
                    </div>
                    <div class="col-md-9">
                        
                            <div class="row">
                                <mat-label class="col-md-4 fw-500 m-b-5 lbl-title-modal"> Họ tên <span class="ob-title"> * </span> </mat-label>
                                <div class="col-md-8">
                                    <mat-form-field class="full-form-field" appearance="outline">
                                        <input matInput formControlName="hoTen" placeholder="Họ tên" autocomplete="off" maxlength="500">
                                        <mat-error *ngIf="userInfoForm.controls.hoTen.hasError('required')"> {{ 'TRE_EM.WARNING.W001' | translate }} </mat-error>
                                        <mat-error *ngIf="userInfoForm.controls.hoTen.hasError('pattern')"> {{ 'TRE_EM.WARNING.W004' | translate }} </mat-error>
                                        <mat-error *ngIf="userInfoForm.controls.hoTen.hasError('maxlength')"> Chuỗi không quá 255 ký tự </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <mat-label class="col-md-4 fw-500 m-b-5 lbl-title-modal"> Chức danh <span class="ob-title"> * </span> </mat-label>
                                <div class="col-md-8">
                                    <mat-form-field class="full-form-field" appearance="outline">
                                        <input matInput formControlName="tenChucDanh" placeholder="Chức danh" autocomplete="off">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row">
                                <mat-label class="col-md-4 fw-500 m-b-5 lbl-title-modal"> Số điện thoại <span class="ob-title"> * </span> </mat-label>
                                <div class="col-md-8">
                                    <mat-form-field class="full-form-field" appearance="outline">
                                        <input matInput formControlName="sdt" placeholder="Số điện thoại" autocomplete="off" maxlength="255">
                                        <mat-error *ngIf="userInfoForm.controls.sdt.hasError('required')"> {{ 'TRE_EM.WARNING.W001' | translate }} </mat-error>
                                        <mat-error *ngIf="userInfoForm.controls.sdt.hasError('pattern')"> Số điện thoại nhập không đúng định dạng </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button mat-raised-button id="add-Family-btn" type="submit" (click)="updateUserInfo()"> Cập nhật </button>
                <button mat-raised-button id="refersh-Family-btn" class="m-l-10" type="button" (click)="closeModal('userInfo')">
                    {{ 'BAO_TRO_XA_HOI.BUTTON.CLOSE' | translate }}
                </button>
            </div>
          </form>
        </div>
    </div>
</div>

<div class="modal fade lims-custom-dialog scroll-dialog" id="password" role="dialog">
    <div class="modal-dialog modal-lg modal-lg-dlg-custom">
        <div class="modal-content">
            <div class="modal-header">
                <div class="title-dialog">
                    <label> Mật khẩu người dùng </label>
                </div>
            </div>
            <form [formGroup]="passwordUserForm">
            <div class="modal-body">
                
                    <div class="row">
                        <mat-label class="col-md-3 fw-500 m-b-5 lbl-title-modal"> Mật khẩu cũ <span class="ob-title"> * </span> </mat-label>
                        <div class="col-md-9">
                            <mat-form-field class="full-form-field" appearance="outline">
                                <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="matKhauCu" placeholder="Mật khẩu cũ" autocomplete="off">
                                <mat-error *ngIf="passwordUserForm.controls.matKhauCu.hasError('required')"> {{ 'TRE_EM.WARNING.W001' | translate }} </mat-error>
                                <mat-error *ngIf="passwordUserForm.controls.matKhauCu.hasError('pattern')">Vui lòng nhập độ dài lớn hơn hoặc bằng 8 ký tự bao gồm ký tự hoa, thường, số và ký tự đặc biệt </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <mat-label class="col-md-3 fw-500 m-b-5 lbl-title-modal"> Mật khẩu mới <span class="ob-title"> * </span> </mat-label>
                        <div class="col-md-9">
                            <mat-form-field class="full-form-field" appearance="outline">
                                <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="matKhauMoi" placeholder="Mật khẩu mới" autocomplete="off">
                                <mat-error *ngIf="passwordUserForm.controls.matKhauMoi.hasError('required')"> {{ 'TRE_EM.WARNING.W001' | translate }} </mat-error>
                                <mat-error *ngIf="passwordUserForm.controls.matKhauMoi.hasError('pattern')">Vui lòng nhập độ dài lớn hơn hoặc bằng 8 ký tự bao gồm ký tự hoa, thường, số và ký tự đặc biệt </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <mat-label class="col-md-3 fw-500 m-b-5 lbl-title-modal"> Nhập lại mật khẩu mới <span class="ob-title"> * </span> </mat-label>
                        <div class="col-md-9">
                            <mat-form-field class="full-form-field" appearance="outline">
                                <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="nhapLaiMatKhauMoi" placeholder="Nhập lại mật khẩu mới" autocomplete="off">
                                <mat-error *ngIf="passwordUserForm.controls.nhapLaiMatKhauMoi.hasError('required')"> {{ 'TRE_EM.WARNING.W001' | translate }} </mat-error>
                                <mat-error *ngIf="passwordUserForm.controls.nhapLaiMatKhauMoi.hasError('pattern')">Vui lòng nhập độ dài lớn hơn hoặc bằng 8 ký tự bao gồm ký tự hoa, thường, số và ký tự đặc biệt </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                
            </div>
            <div class="modal-footer">
                <button mat-raised-button id="add-Family-btn" type="submit" (click)="updatePasswordUser()"> Cập nhật </button>
                <button mat-raised-button id="refersh-Family-btn" class="m-l-10" type="button" (click)="closeModal('password')">
                    {{ 'BAO_TRO_XA_HOI.BUTTON.CLOSE' | translate }}
                </button>
            </div>
          </form>
        </div>
    </div>
</div>

<div class="modal fade lims-custom-dialog scroll-dialog" id="modalUserId_admin" role="dialog">
    <div class="modal-dialog modal-lg-dlg-custom">
        <div class="modal-content modal-nhap-userid">
            <div class="modal-header">
                <div class="title-dialog">
                    <label> Nhập tài khoản quản lý văn bản</label>
                </div>
            </div>
            <div class="modal-body">
                <form [formGroup]="userIdForm">
                    <div class="row mb-10">
                        <div class="col-md-12">
                        <mat-form-field appearance="outline" class="full-form-field">
                            <input matInput formControlName="tenDangNhapQLVB" placeholder="Nhập tài khoản quản lý văn bản">
                            <mat-error
                            *ngIf="userIdForm.get('tenDangNhapQLVB')?.errors?.required && userIdForm.get('tenDangNhapQLVB')?.touched"
                            style="color: red; margin-top: 0px !important;">
                            Đây là trường bắt buộc
                            </mat-error>
                        </mat-form-field>
                        </div>
                    </div>
                    <div class="row mb-10">
                        <div class="col-md-12">
                        <mat-form-field appearance="outline" class="full-form-field">
                            <input matInput
                                [type]="hidePassword ? 'password' : 'text'"
                                formControlName="matKhauQLVB"
                                placeholder="Nhập mật khẩu tài khoản quản lý văn bản">
                            <button mat-icon-button matSuffix (click)="togglePasswordVisibility()" type="button">
                            <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                            </button>
                            <mat-error
                            *ngIf="userIdForm.get('matKhauQLVB')?.errors?.required && userIdForm.get('matKhauQLVB')?.touched"
                            style="color: red; margin-top: 0px !important;">
                            Đây là trường bắt buộc
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                </form>
            </div>
            <div class="modal-footer">
                <button mat-raised-button id="add-Family-btn" (click)="submitUserId()">
                    Xác nhận
                </button>
                <button mat-raised-button id="refersh-Family-btn" class="m-l-10" align="start"
                    (click)="closeModal('modalUserId_admin')">
                    Đóng
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade lims-custom-dialog scroll-dialog" id="addThongTinDoanhNhiep" role="dialog">
    <div class="modal-dialog modal-lg modal-lg-dlg-custom modal-lg-custom">
        <div class="modal-content">
            <div class="modal-header">
                <div class="title-dialog">
                    <label> {{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.CAP_NHAT_DOANH_NGHIEP' | translate }} </label>
                </div>
            </div>
            <div class="modal-body-vlg">
                <form [formGroup]="addForm" #formDirective="ngForm"
                (submit)="capNhat()"
                >
                    <div class="row">
                        <span class="title-info m-b-10"> <strong class="m-l-5"> {{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.THONG_TIN_DOANH_NGHIEP' | translate }} </strong> </span>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.TEN_DOANH_NGHIEP' | translate }} <span class="ob-title"> *</span></mat-label>
                                <input matInput formControlName="tenCoSo"
                                (blur)="trimSpace($event, addForm.controls.tenCoSo)"
                                maxlength="250"
                                (input)="validateInputDN($event)"
                                placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.TEN_DOANH_NGHIEP' | translate }}">
                                <mat-error *ngIf="addForm.controls.tenCoSo.hasError('required')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.REQUIRED' | translate }}
                                </mat-error>
                                <mat-error *ngIf="addForm.controls.tenCoSo.hasError('pattern')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.PATTERT_SYMBOL' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.MA_SO_THUE' | translate }} <span class="ob-title"> *</span></mat-label>
                                <input matInput formControlName="maSoThue"
                                        maxlength="250"
                                        (input)="validateInputDN($event)"
                                        (blur)="trimSpace($event, addForm.controls.maSoThue);"
                                        placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.MA_SO_THUE' | translate }}"/>
                                <mat-error *ngIf="addForm.controls.maSoThue.hasError('required')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.REQUIRED' | translate }}
                                </mat-error>
                                <mat-error *ngIf="addForm.controls.maSoThue.hasError('pattern')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.PATTERT_SYMBOL' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <lims-dropdown placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.LOAI_HINH_DOANH_NGHIEP' | translate }}"
                                            [data]="danhMucLoaiHinhCoSo ? danhMucLoaiHinhCoSo : []"
                                            label="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.LOAI_HINH_DOANH_NGHIEP' | translate }}"
                                            required="true"
                                            [formControl]="addForm.controls.loaiHinhCoSo" keyId="id"
                                            noEntriesFoundLabel="{{ 'CUNG_CAU_LAO_DONG.DUNG_CHUNG.KHONG_TIM_THAY_KET_QUA' | translate }}"
                                            error="{{ 'CUNG_CAU_LAO_DONG.VALIDATION.REQUIRED' | translate }}"
                                            keyName="name" class="w100">
                            </lims-dropdown>
                        </div>
                        <div class="col-md-3">
                            <lims-dropdown placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.LINH_VUC_SAN_XUAT_CHINH' | translate }}"
                                            label="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.LINH_VUC_SAN_XUAT_CHINH' | translate }}"
                                            required="true"
                                            [data]="danhMucLinhVucSXChinh ? danhMucLinhVucSXChinh : []"
                                            [formControl]="addForm.controls.linhVucSanXuatChinh" keyId="id"
                                            noEntriesFoundLabel="{{ 'CUNG_CAU_LAO_DONG.DUNG_CHUNG.KHONG_TIM_THAY_KET_QUA' | translate }}"
                                            error="{{ 'CUNG_CAU_LAO_DONG.VALIDATION.REQUIRED' | translate }}"
                                            keyName="ten_nganh" class="w100">
                            </lims-dropdown>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <lims-dropdown placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.TINH_TRANG_HOAT_DONG' | translate }}"
                                            [data]="danhMucTinhTrangHoatDong ? danhMucTinhTrangHoatDong : []"
                                            label="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.TINH_TRANG_HOAT_DONG' | translate }}"
                                            required="true"
                                            [formControl]="addForm.controls.tinhTrangHoatDong" keyId="id"
                                            noEntriesFoundLabel="{{ 'CUNG_CAU_LAO_DONG.DUNG_CHUNG.KHONG_TIM_THAY_KET_QUA' | translate }}"
                                            error="{{ 'CUNG_CAU_LAO_DONG.VALIDATION.REQUIRED' | translate }}"
                                            keyName="name" class="w100">
                            </lims-dropdown>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.NGAY_THANH_LAP' | translate }}</mat-label>
                                <input matInput formControlName="ngayThanhLap" [matDatepicker]="picker4"  (keypress)="keyPressDate($event)"
                                    placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.NGAY_THANH_LAP' | translate }}" [max]="date"/>
                                <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                                <mat-datepicker #picker4></mat-datepicker>
                                <mat-error *ngIf="addForm.controls.ngayThanhLap.hasError('matDatepickerParse')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.PATTERN_DATE2' | translate }}
                                </mat-error>
                                <mat-error *ngIf="addForm.controls.ngayThanhLap.hasError('matDatepickerMax')">
                                {{ 'CUNG_CAU_LAO_DONG.VALIDATION.MAX_CURRENT' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.SO_DIEN_THOAI' | translate }}</mat-label>
                                <input matInput formControlName="soDienThoai" (keypress)="allowPressNumber($event)"
                                (blur)="trimSpace($event, addForm.controls.soDienThoai)"
                                maxlength="11"
                                placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.SO_DIEN_THOAI' | translate }}"/>
                                <mat-error *ngIf="addForm.controls.soDienThoai.hasError('pattern')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.PARTERT_PHONENUMBER' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.EMAIL' | translate }}</mat-label>
                                <input matInput formControlName="email"
                                maxlength="250"
                                (input)="validateInputDN($event)"
                                (blur)="trimSpace($event, addForm.controls.email)"
                                placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.EMAIL' | translate }}"/>
                                <mat-error *ngIf="addForm.controls.email.hasError('pattern')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.PATTERT_EMAIL' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.FAX' | translate }}</mat-label>
                                <input matInput formControlName="fax"
                                maxlength="250"
                                (blur)="trimSpace($event, addForm.controls.fax)"
                                placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.FAX' | translate }}"/>
                                <mat-error *ngIf="addForm.controls.fax.hasError('pattern')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.PATTERT_SYMBOL' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.WEBSITE' | translate }}</mat-label>
                                <input matInput formControlName="webSite"
                                maxlength="1000"
                                (blur)="trimSpace($event, addForm.controls.webSite)"
                                placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.WEBSITE' | translate }}"/>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <br>
                            <mat-checkbox formControlName="toChucCongDoan"
                            (change) = "checkThanhLapCongDoan(addForm.controls.toChucCongDoan.value,addForm.controls.namThanhLapCongDoan)"
                            labelPosition="before">{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.DA_THANH_LAP_CONG_DOAN' | translate }}</mat-checkbox>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.NGAY_THANH_LAP_CONG_DOAN' | translate }}</mat-label>
                                <input matInput formControlName="namThanhLapCongDoan" [matDatepicker]="picker5" (keypress)="allowPressDate($event)"
                                    placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.NGAY_THANH_LAP_CONG_DOAN' | translate }}" [max]="date"/>
                                <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
                                <mat-datepicker #picker5></mat-datepicker>
                                <mat-error *ngIf="addForm.controls.namThanhLapCongDoan.hasError('matDatepickerParse')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.PATTERN_DATE2' | translate }}
                                </mat-error>
                                <mat-error *ngIf="addForm.controls.namThanhLapCongDoan.hasError('matDatepickerMax')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.MAX_CURRENT' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                         <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>Cơ quan quản lý trực tiếp</mat-label>
                                <input matInput formControlName="cqQuabLyTrucTiep"
                                maxlength="1000"
                                (blur)="trimSpace($event, addForm.controls.cqQuabLyTrucTiep)"
                                placeholder="Cơ quan quản lý trực tiếp"/>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <span class="title-info m-b-10"> <strong class="m-l-5"> {{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.THONG_TIN_DIA_CHI' | translate }} </strong> </span>
                    </div>
            <!-- Địa chỉ nơi ở hiện tại -->
                    <div class="row">
                        <div class="col-md-3">
                            <lims-dropdown placeholder="{{ 'CUNG_CAU_LAO_DONG.DUNG_CHUNG.TINH_THANH' | translate }}"
                                    [data]="danhMucTinhThanhAdd ? danhMucTinhThanhAdd : []"
                                    label="{{ 'CUNG_CAU_LAO_DONG.DUNG_CHUNG.TINH_THANH' | translate }}"
                                    required="true"
                                    disabled
                                    [formControl]="addForm.controls.maTinh" keyId="MA_TINH_THANH_BHXH"
                                    noEntriesFoundLabel="{{ 'CUNG_CAU_LAO_DONG.DUNG_CHUNG.KHONG_TIM_THAY_KET_QUA' | translate }}"
                                    keyName="TEN_TINH_THANH" class="w100" (selected)="setMaTinh();"
                                    error="{{ 'CUNG_CAU_LAO_DONG.VALIDATION.REQUIRED' | translate }}"
                                    >
                            </lims-dropdown>
                        </div>
                        <div class="col-md-3">
                            <lims-dropdown placeholder="{{ 'CUNG_CAU_LAO_DONG.DUNG_CHUNG.XA_PHUONG' | translate }}"
                                    [data]="danhMucPhuongXaAdd ? danhMucPhuongXaAdd : []"
                                    label="{{ 'CUNG_CAU_LAO_DONG.DUNG_CHUNG.XA_PHUONG' | translate }}"
                                    required="true"
                                    [formControl]="addForm.controls.maXa" keyId="maXaPhuongBhxh"
                                    noEntriesFoundLabel="{{ 'CUNG_CAU_LAO_DONG.DUNG_CHUNG.KHONG_TIM_THAY_KET_QUA' | translate }}"
                                    keyName="tenXaPhuong" class="w100"
                                    error="{{ 'CUNG_CAU_LAO_DONG.VALIDATION.REQUIRED' | translate }}"
                                    >
                            </lims-dropdown>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.DUNG_CHUNG.DIA_CHI_CU_THE' | translate }}</mat-label>
                                <input matInput formControlName="diaChi" (input)="validateInputDN($event)" maxlength="1000" placeholder=" {{ 'CUNG_CAU_LAO_DONG.DUNG_CHUNG.DIA_CHI_CU_THE' | translate }}">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <span class="title-info m-b-10"> <strong class="m-l-5"> {{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.NOI_QUY_LAO_DONG' | translate }} </strong> </span>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <lims-dropdown placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.TRANG_THAI' | translate }}"
                                [data]="[
                                    { id: 0, name: ('CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.CHUA_BAN_HANH' | translate) },
                                    { id: 1, name: ('CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.DA_BAN_HANH' | translate) }
                                ]"
                                label="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.TRANG_THAI' | translate }}"
                                [formControl]="addForm.controls.trangThaiBanHanhNoiQuy"
                                keyId="id" keyName="name"
                                noEntriesFoundLabel="{{ 'CUNG_CAU_LAO_DONG.DUNG_CHUNG.KHONG_TIM_THAY_KET_QUA' | translate }}"
                                class="w100">
                            </lims-dropdown>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.NGAY_BAN_HANH' | translate }}</mat-label>
                                <input matInput formControlName="ngayBanHanhNoiQuy" [matDatepicker]="picker7" (keypress)="allowPressDate($event)"
                                    placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.NGAY_BAN_HANH' | translate }}" [max]="date"/>
                                <mat-datepicker-toggle matSuffix [for]="picker7"></mat-datepicker-toggle>
                                <mat-datepicker #picker7></mat-datepicker>
                                <mat-error *ngIf="addForm.controls.ngayBanHanhNoiQuy.hasError('matDatepickerParse')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.PATTERN_DATE2' | translate }}
                                </mat-error>
                                <mat-error *ngIf="addForm.controls.ngayBanHanhNoiQuy.hasError('matDatepickerMax')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.MAX_CURRENT' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.CO_QUAN_XET_DUYET' | translate }}</mat-label>
                                <input matInput formControlName="coQuanXetNoiQuy"
                                    maxlength="250"
                                    (input)="validateInputDN($event)"
                                    (blur)="trimSpace($event, addForm.controls.coQuanXetNoiQuy)"
                                    placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.CO_QUAN_XET_DUYET' | translate }}">
                                <mat-error *ngIf="addForm.controls.coQuanXetNoiQuy.hasError('pattern')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.PATTERT_SYMBOL' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <span class="title-info m-b-10"> <strong class="m-l-5"> {{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.THOA_UOC_LAO_DONG_TAP_THE' | translate }} </strong> </span>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <lims-dropdown placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.TRANG_THAI' | translate }}"
                                [data]="[
                                    { id: 0, name: ('CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.CHUA_BAN_HANH' | translate) },
                                    { id: 1, name: ('CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.DA_BAN_HANH' | translate) }
                                ]"
                                label="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.TRANG_THAI' | translate }}"
                                [formControl]="addForm.controls.trangThaiBanHanhThoaUocLdtt"
                                keyId="id" keyName="name"
                                noEntriesFoundLabel="{{ 'CUNG_CAU_LAO_DONG.DUNG_CHUNG.KHONG_TIM_THAY_KET_QUA' | translate }}"
                                class="w100">
                            </lims-dropdown>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.NGAY_BAN_HANH' | translate }}</mat-label>
                                <input matInput formControlName="ngayBanHanhThoaUocLdtt" [matDatepicker]="picker8" (keypress)="allowPressDate($event)"
                                    placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.NGAY_BAN_HANH' | translate }}" [max]="date"/>
                                <mat-datepicker-toggle matSuffix [for]="picker8"></mat-datepicker-toggle>
                                <mat-datepicker #picker8></mat-datepicker>
                                <mat-error *ngIf="addForm.controls.ngayBanHanhThoaUocLdtt.hasError('matDatepickerParse')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.PATTERN_DATE2' | translate }}
                                </mat-error>
                                <mat-error *ngIf="addForm.controls.ngayBanHanhThoaUocLdtt.hasError('matDatepickerMax')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.MAX_CURRENT' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.CO_QUAN_XET_DUYET' | translate }}</mat-label>
                                <input matInput formControlName="coQuanXetThoaUocLdtt"
                                    maxlength="250"
                                    (input)="validateInputDN($event)"
                                    (blur)="trimSpace($event, addForm.controls.coQuanXetThoaUocLdtt)"
                                    placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.CO_QUAN_XET_DUYET' | translate }}">
                                <mat-error *ngIf="addForm.controls.coQuanXetThoaUocLdtt.hasError('pattern')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.PATTERT_SYMBOL' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <span class="title-info m-b-10"> <strong class="m-l-5"> {{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.THONG_TIN_NGUOI_DAI_DIEN' | translate }} </strong> </span>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.HO_TEN' | translate }}</mat-label>
                                <input matInput formControlName="hoTen"
                                maxlength="250"
                                (input)="validateInputDN($event)"
                                (blur)="trimSpace($event, addForm.controls.hoTen)"
                                placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.HO_TEN' | translate }}">
                                <mat-error *ngIf="addForm.controls.hoTen.hasError('required')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.REQUIRED' | translate }}
                                </mat-error>
                                <mat-error *ngIf="addForm.controls.hoTen.hasError('pattern')">
                                {{ 'CUNG_CAU_LAO_DONG.VALIDATION.PATTERT_SYMBOL' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <lims-dropdown placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.GIOI_TINH' | translate }}" 
                                [data]="danhMucGioiTinh ? danhMucGioiTinh : []"
                                label="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.GIOI_TINH' | translate }}"
                                [formControl]="addForm.controls.gioiTinh" keyId="id"
                                noEntriesFoundLabel="{{ 'CUNG_CAU_LAO_DONG.DUNG_CHUNG.KHONG_TIM_THAY_KET_QUA' | translate }}"
                                keyName="name" class="w100"
                                error="{{ 'CUNG_CAU_LAO_DONG.VALIDATION.REQUIRED' | translate }}"
                                >
                            </lims-dropdown>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.NGAY_SINH' | translate }}</mat-label>
                                <input matInput formControlName="ngaySinh" [matDatepicker]="picker6" (keypress)="allowPressDate($event)"
                                    placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.NGAY_SINH' | translate }}" [max]="date"/>
                                <mat-datepicker-toggle matSuffix [for]="picker6"></mat-datepicker-toggle>
                                <mat-datepicker #picker6></mat-datepicker>
                                <mat-error *ngIf="addForm.controls.ngaySinh.hasError('matDatepickerParse')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.PATTERN_DATE2' | translate }}
                                </mat-error>
                                <mat-error *ngIf="addForm.controls.ngaySinh.hasError('matDatepickerMax')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.MAX_CURRENT' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.CHUC_DANH' | translate }}</mat-label>
                                <input matInput formControlName="chucDanh"
                                maxlength="250"
                                (input)="validateInputDN($event)"
                                (blur)="trimSpace($event, addForm.controls.chucDanh)"
                                placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.CHUC_DANH' | translate }}">
                                <mat-error *ngIf="addForm.controls.chucDanh.hasError('required')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.REQUIRED' | translate }}
                                </mat-error>
                                <mat-error *ngIf="addForm.controls.chucDanh.hasError('pattern')">
                                {{ 'CUNG_CAU_LAO_DONG.VALIDATION.PATTERT_SYMBOL' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.CCCC_CMND' | translate }}</mat-label>
                                <input matInput placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.CCCC_CMND' | translate }}"
                                formControlName="cccd"
                                maxlength="12"
                                (blur)="trimSpace($event, addForm.controls.cccd)"
                                (keypress)="allowPressNumber($event)">
                                <mat-error *ngIf="addForm.controls.cccd.hasError('pattern')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.PATTERN_CMND' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.NGAY_CAP' | translate }}</mat-label>
                                <input matInput formControlName="ngayCap" [matDatepicker]="picker2" (keypress)="allowPressDate($event)"
                                    placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.NGAY_CAP' | translate }}" [max]="date"/>
                                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                <mat-datepicker #picker2></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.NOI_CAP' | translate }}</mat-label>
                                <input matInput formControlName="noiCap"
                                maxlength="250"
                                (input)="validateInputDN($event)"
                                placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.NOI_CAP' | translate }}"
                                (blur)="trimSpace($event, addForm.controls.noiCap)">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.SO_DIEN_THOAI' | translate }}</mat-label>
                                <input matInput formControlName="sdtDD" (keypress)="allowPressNumber($event)"
                                (blur)="trimSpace($event, addForm.controls.sdtDD)"
                                maxlength="11"
                                placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.SO_DIEN_THOAI' | translate }}"/>
                                <mat-error *ngIf="addForm.controls.sdtDD.hasError('pattern')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.PARTERT_PHONENUMBER' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field class="input-group w100" appearance="outline">
                                <mat-label>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.EMAIL' | translate }}</mat-label>
                                <input matInput formControlName="emailDD"
                                maxlength="250"
                                (blur)="trimSpace($event, addForm.controls.emailDD)"
                                placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.EMAIL' | translate }}"/>
                                <mat-error *ngIf="addForm.controls.emailDD.hasError('pattern')">
                                    {{ 'CUNG_CAU_LAO_DONG.VALIDATION.PATTERT_EMAIL' | translate }}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <span class="title-info m-b-10"> <strong class="m-l-5"> {{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.THONG_TIN_GIAY_PHEP' | translate }} </strong> </span>
                    </div>
            <!-- Dịch vụ được cung cấp - Ghi chú -->
                    <div class="row">
                        <div class="col-md-12 search-table-outter wrapper overflow-auto ">
                            <div class="multi-table-input ">
                                <table>
                                <tbody class="table-input">
                                    <tr style="background-color: #3c8dbccc;">
                                    <th>{{ 'CUNG_CAU_LAO_DONG.DUNG_CHUNG.STT' | translate }}</th>
                                    <th>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.NGAY_CAP_GIAY_PHEP' | translate }} <span class="ob-title">*</span></th>
                                    <th>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.LOAI_GIAY_PHEP' | translate }} <span class="ob-title">*</span></th>
                                    <th>{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.FILE_DINH_KEM' | translate }} <span class="ob-title">*</span></th>
                                    <th>{{ 'CUNG_CAU_LAO_DONG.DUNG_CHUNG.THAO_TAC' | translate }}</th>
                                    </tr>
                                    <tr *ngFor="let row of addGPKDForm.get('rows')?.controls; let index = index;">
                                    <td >{{ index + 1 }}</td>
                                    <td>
                                        <mat-form-field class="input-group" appearance="outline">
                                            <input matInput [formControl]="row.get('ngayCapGiayPhep')" [matDatepicker]="picker_ngayCap" (keypress)="allowPressDate($event)"
                                                placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.NGAY_CAP_GIAY_PHEP' | translate }}" [max]="date"/>
                                            <mat-datepicker-toggle matSuffix [for]="picker_ngayCap"></mat-datepicker-toggle>
                                            <mat-datepicker #picker_ngayCap></mat-datepicker>
                                            <mat-error *ngIf="row.get('ngayCapGiayPhep').hasError('required') && row.get('ngayCapGiayPhep').errors.matDatepickerParse == undefined">
                                                {{ 'CUNG_CAU_LAO_DONG.VALIDATION.REQUIRED' | translate }}
                                            </mat-error>
                                            <mat-error *ngIf="row.get('ngayCapGiayPhep').hasError('matDatepickerParse')">
                                                {{ 'CUNG_CAU_LAO_DONG.VALIDATION.PATTERN_DATE2' | translate }}
                                            </mat-error>
                                            <mat-error *ngIf="row.get('ngayCapGiayPhep').hasError('matDatepickerMax')">
                                                {{ 'CUNG_CAU_LAO_DONG.VALIDATION.MAX_CURRENT' | translate }}
                                            </mat-error>
                                        </mat-form-field>
                                    </td>
                                    <td>
                                        <mat-form-field class="input-group w100" appearance="outline">
                                            <input matInput [formControl]="row.get('loaiGiayPhep')"
                                            maxlength="250"
                                            (input)="validateInputDN($event)"
                                            placeholder="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.LOAI_GIAY_PHEP' | translate }}"
                                            (blur)="trimSpace($event, row.get('loaiGiayPhep'))">
                                            <mat-error *ngIf="row.get('loaiGiayPhep').hasError('required')">
                                                {{ 'CUNG_CAU_LAO_DONG.VALIDATION.REQUIRED' | translate }}
                                            </mat-error>
                                            <mat-error *ngIf="row.get('loaiGiayPhep').hasError('pattern')">
                                                {{ 'CUNG_CAU_LAO_DONG.VALIDATION.PATTERT_SYMBOL' | translate }}
                                            </mat-error>
                                        </mat-form-field>
                                    </td>
                                    <td style="text-align: left">
                                        <a href="#" (click)="downFileGPKD($event,row.get('idfile')?.value, row.get('fileName')?.value)">{{ row.get('fileName')?.value || '' }}</a>
                                    </td>
                                    <td>
                                        <input type="file" (change)="onFileChange($event, index)" style="display: none;" #fileInput>
                                        <button class="mat-icon-recover"
                                            type="button"
                                            (click)="fileInput.click()"
                                            matTooltip="{{ 'CUNG_CAU_LAO_DONG.QUAN_LY_DOANH_NGHIEP.FILE_DINH_KEM' | translate }}" style="margin-right: 2px;">
                                                    <span class="fa fa-file-lines icon"></span>
                                    </button>
                                        <button class="mat-icon-delete" matTooltip="{{ 'CUNG_CAU_LAO_DONG.CONTROL.XOA' | translate }}" type="button" (click)="xoaDong(index,row.get('id').value)">
                                        <span class="fa fa-close icon"></span>
                                        </button>
                                    </td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                            </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <button mat-raised-button id="refersh-Family-btn" class="m-l-10" type="button" (click)="onAddRow()">
                                {{ 'CUNG_CAU_LAO_DONG.CONTROL.THEM_DONG_MOI' | translate }}
                            </button>
                        </div>
                    </div>
                    <div class="modal-footer" style="margin-top: 40px;">
                        <button mat-raised-button id="add-Family-btn"
                            type="submit">
                            {{ 'CUNG_CAU_LAO_DONG.CONTROL.CAP_NHAT' | translate }}
                        </button>
                        <button mat-raised-button id="refersh-Family-btn" type="button" class="m-l-10" (click)="closeModal('addThongTinDoanhNhiep');">
                            {{ 'CUNG_CAU_LAO_DONG.CONTROL.DONG' | translate }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>